<template>
  <v-container fluid py-0 :px-0="$vuetify.breakpoint.mdAndUp">
    <v-layout row wrap>
      <v-flex xs12 md2>
        <v-select
          v-model="notificacaoSelected"
          :items="filtroNotificacoes"
          item-text="text"
          item-value="value"
          hide-details
          prepend-icon="description"
          label="Filtrar Notificacoes"
          @change="filtraNotificacoes"
        ></v-select>
      </v-flex>
      <v-flex xs12 md4 v-if="notificacaoSelected == 'periodo'">
        <div class="d-flex">
          <v-menu v-model="periodoDatepickerInicial" full-width>
            <v-text-field readonly slot="activator"
              :value="moment(periodo.dataInicial).format('DD/MM/YYYY')" label="Data Inicial" prepend-icon="event">
            </v-text-field>
            <v-date-picker locale="pt" v-model="periodo.dataInicial"></v-date-picker>
          </v-menu>
          <v-menu v-model="periodoDatepickerFinal" full-width>
            <v-text-field readonly slot="activator"
              :value="moment(periodo.dataFinal).format('DD/MM/YYYY')" label="Data Final" prepend-icon="event">
            </v-text-field>
            <v-date-picker locale="pt" v-model="periodo.dataFinal"></v-date-picker>
          </v-menu>
          <v-tooltip bottom>
            <v-btn fab dark small color="primary" icon @click="aplicaFiltroPeriodo" slot="activator">
              <v-icon>done</v-icon>
            </v-btn>
            <span>Aplicar</span>
          </v-tooltip>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'FiltroNotificacao',
  data: () => ({
    notificacaoSelected: 'hoje',
    filtroNotificacoes: [
      { text: 'Hoje', value: 'hoje' },
      { text: 'Semana', value: 'semana' },
      { text: 'Mês', value: 'mes' },
      { text: 'Período', value: 'periodo' },
    ],
    periodoDatepickerInicial: false,
    periodoDatepickerFinal: false,
    periodo: {
      dataInicial: new Date().toISOString().substr(0, 10),
      dataFinal: new Date().toISOString().substr(0, 10)
    },
  }),
  methods: {
    aplicaFiltroPeriodo() {
      this.$emit('filtraNotificacoesLidas', { tipo: this.notificacaoSelected, data: this.periodo});
    },
    filtraNotificacoes() {
      if (this.notificacaoSelected !== 'periodo') {
        this.$emit('filtraNotificacoesLidas', { tipo: this.notificacaoSelected, data: this.periodo});
      }
    }
  }
}
</script>

<style>

</style>